import callApi from 'client/util/apiCaller';
import { createActions } from 'redux-actions';

export const {
  fetchOrganizationSuccess,
  fetchOrganizationError,
  updateOrganizationSuccess,
  updateOrganizationError,
  uploadLogoSuccess,
  uploadLogoError,
  deleteLogoSuccess,
  deleteLogoError,
} = createActions(
  'FETCH_ORGANIZATION_SUCCESS',
  'FETCH_ORGANIZATION_ERROR',
  'UPDATE_ORGANIZATION_SUCCESS',
  'UPDATE_ORGANIZATION_ERROR',
  'UPLOAD_LOGO_SUCCESS',
  'UPLOAD_LOGO_ERROR',
  'DELETE_LOGO_SUCCESS',
  'DELETE_LOGO_ERROR',
);

// Organization API actions (thunks). These return API responses and can be
// composed by components;

export function fetchOrganization(token, organizationId) {
  return dispatch => {
    return callApi(dispatch, `organizations/${organizationId}`, token, 'GET')
      .then(response => {
        dispatch(fetchOrganizationSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(fetchOrganizationError(error.message || error));
        throw error;
      });
  };
}

export function updateOrganization(token, organizationId, data) {
  return dispatch => {
    return callApi(dispatch, `organizations/${organizationId}`, token, 'PUT', data)
      .then(response => {
        dispatch(updateOrganizationSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(updateOrganizationError(error.message || error));
        throw error;
      });
  };
}

export function startDomainVerification(token, organizationId, domain) {
  return dispatch => {
    return callApi(dispatch, `organizations/${organizationId}/domain/verify/start`, token, 'POST', {
      domain,
    });
  };
}

export function confirmDomainVerification(token, organizationId, domain) {
  return dispatch => {
    return callApi(
      dispatch,
      `organizations/${organizationId}/domain/verify/confirm`,
      token,
      'POST',
      { domain },
    );
  };
}

export function removeDomainVerification(token, organizationId, domain) {
  return dispatch => {
    return callApi(
      dispatch,
      `organizations/${organizationId}/domain/${encodeURIComponent(domain)}`,
      token,
      'DELETE',
    );
  };
}

export function fetchOrganizationMembers(organizationId, token) {
  return (dispatch, _getState) => {
    return callApi(dispatch, `organizations/${organizationId}/members`, token, 'GET');
  };
}

export function generateLogoUploadUrl(organizationId, contentType, filename) {
  return dispatch => {
    return callApi(dispatch, `organizations/${organizationId}/logo/sign`, null, 'POST', {
      contentType,
      filename,
    });
  };
}

export function updateOrganizationLogo(organizationId, logoUrl, filename) {
  return dispatch => {
    return callApi(dispatch, `organizations/${organizationId}/logo`, null, 'PUT', {
      logoUrl,
      filename,
    })
      .then(response => {
        dispatch(updateOrganizationSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(uploadLogoError(error.message || error));
        throw error;
      });
  };
}

export function deleteOrganizationLogo(organizationId) {
  return dispatch => {
    return callApi(dispatch, `organizations/${organizationId}/logo`, null, 'DELETE')
      .then(response => {
        dispatch(updateOrganizationSuccess(response));
        return response;
      })
      .catch(error => {
        dispatch(deleteLogoError(error.message || error));
        throw error;
      });
  };
}
